import { invert } from 'lodash';

import { roomStatusesByName } from './roomStatuses';

export enum BoardTypeNames {
  Concept = 'Concept',
  'Initial Design' = 'Initial Design',
  Design = 'Design',
  Predesign = 'Predesign',
  Gift = 'Gift',
  'Registry Suggestions' = 'Registry Suggestions',
  Looks = 'Looks',
  Dorm = 'Dorm',
  Consult = 'Consult',
  Holiday = 'Holiday',
  Package = 'Package',
  'Curated Boards' = 'Curated Boards',
  'Profile Layout' = 'Profile Layout',
  'Havenly Personal Order' = 'Havenly Personal Order',
  'Final Concept' = 'Final Concept',
  Essentials = 'Essentials',
  Trends = 'Trends',
  'Havenly Favorites' = 'Havenly Favorites',
  'Quick Ship Bundle' = 'Quick Ship Bundle',
  'Quick Ship Category' = 'Quick Ship Category',
  'Room Improvements' = 'Room Improvements',
  Idea = 'Idea',
  'Project Board' = 'Project Board',
  Collection = 'Collection',
}

export const boardTypes: { [key in BoardTypeNames]: number } = {
  Concept: 1,
  'Initial Design': 2,
  Design: 3,
  Predesign: 4,
  Gift: 5,
  'Registry Suggestions': 6,
  Looks: 7,
  Dorm: 8,
  Consult: 9,
  Holiday: 10,
  Package: 11,
  'Curated Boards': 12,
  'Profile Layout': 13,
  'Havenly Personal Order': 14,
  'Final Concept': 15,
  Essentials: 16,
  Trends: 17,
  'Havenly Favorites': 18,
  'Quick Ship Bundle': 19,
  'Quick Ship Category': 20,
  'Room Improvements': 21,
  Idea: 22,
  'Project Board': 23,
  Collection: 24,
};

export const boardTypesById = invert(boardTypes);

export const boardTypesToAnalyticsTerm = new Map([
  [boardTypes.Idea, 'Idea'],
  [boardTypes.Concept, 'Concept'],
  [boardTypes.Design, 'Design']
]);

enum InPersonBoards {
  DESIGN_PROPOSAL = 'Design Proposal',
  VISION_BOARD = 'Vision Board',
  '3D_DESIGN' = '3D Design'
}

export const inPersonBoardTypeMapping: { [K: string]: string } = {
  Concept: InPersonBoards.DESIGN_PROPOSAL,
  Ideas: InPersonBoards.VISION_BOARD,
  Design: InPersonBoards['3D_DESIGN']
};

// A list of board types ordered to surface categories for most recent room status at top.
export const boardTypesByProcessOrder: { [key: string]: number } = {
  Design: boardTypes.Design,
  'Final Concept': boardTypes['Final Concept'],
  Concept: boardTypes.Concept,
  Ideas: boardTypes.Idea,
  Consult: boardTypes.Consult,
  Other: -1, // Other is an artificial board type used for grouping extranneous boards
};

// A list of board types which don't have room_id or user_id associations
export const nonClientBoardTypes = {
  Collection: boardTypes.Collection,
  'Profile Layout': boardTypes['Profile Layout'],
};

// A list of board types by room status which are allowed to be published.
export const canPublishBoardMap = {
  [roomStatusesByName.PROSPECT]: [],
  [roomStatusesByName.CONSULTATION_COMPLETE]: [],
  [roomStatusesByName.ON_HOLD]: [],
  [roomStatusesByName.CLOSED]: [],
  [roomStatusesByName.DESIGN_PROCESS_COMPLETE]: [
    boardTypes.Design,
  ],
  [roomStatusesByName.AWAITING_IDEAS]: [
    boardTypes.Idea,
  ],
  [roomStatusesByName.IDEA_REVIEW]: [
    boardTypes.Idea,
  ],
  [roomStatusesByName.AWAITING_CONCEPT]: [
    boardTypes.Concept,
  ],
  [roomStatusesByName.CONCEPT_REVIEW]: [
    boardTypes.Concept,
  ],
  [roomStatusesByName.AWAITING_FINAL_CONCEPT]: [
    boardTypes['Final Concept'],
  ],
  [roomStatusesByName.FINAL_CONCEPT_REVIEW]: [
    boardTypes['Final Concept'],
  ],
  [roomStatusesByName.AWAITING_DESIGN]: [
    boardTypes.Design,
  ],
  [roomStatusesByName.DESIGN_REVIEW]: [
    boardTypes.Design,
  ],
  [roomStatusesByName.CONSULT_READY]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.CONSULT_ACTIVE]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.CONSULT_AWAITING_BOARD]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.CONSULT_AWAITING_FEEDBACK]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.CONSULT_COMPLETE]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.CONSULT_ON_HOLD]: [
    boardTypes.Consult,
  ],
  [roomStatusesByName.AWAITING_DELIVERABLE]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName.DELIVERABLE_REVIEW]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  // @TODO - HIP board types
  [roomStatusesByName.AWAITING_VISION_BOARD]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName.VISION_BOARD_REVIEW]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName.AWAITING_DESIGN_PROPOSAL]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName.DESIGN_PROPOSAL_REVIEW]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName.AWAITING_3D_DESIGN]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ],
  [roomStatusesByName['3D_DESIGN_REVIEW']]: [
    boardTypes.Idea,
    boardTypes.Concept,
    boardTypes.Design
  ]
};

export const REVIEW_BOARD_TYPES = [
  boardTypes.Concept,
  boardTypes['Initial Design'],
  boardTypes.Design,
  boardTypes.Consult,
  boardTypes['Final Concept'],
];

export const BOARD_TYPES_WITH_OPTIONS = [
  boardTypes.Concept,
  boardTypes['Profile Layout'],
  boardTypes['Final Concept'],
  boardTypes.Design,
];
